export class AdditionalDriverModel {
  birthDate: Date;
  drivingLicenseIssueYear: number;
  drivingLicenseIssueMonth: number;
}
